import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';

import debounce from 'utils/debounce';

const InfiniteScroll = ({
  children,
  loadData,
  loadMoreData = true,
  lastItem,
}) => {
  const rootEl = document.getElementById('root');

  const onScroll = debounce(() => {
    const maxScrollHeight = rootEl.scrollHeight;
    const scrollBottomPosition = rootEl.scrollTop + rootEl.clientHeight;

    const TOLERANCE = window.innerHeight / 2;

    const shouldLoadMoreItems =
      scrollBottomPosition + TOLERANCE >= maxScrollHeight;

    if (shouldLoadMoreItems && loadMoreData) loadData();
  }, 500);

  useEffect(() => {
    rootEl.addEventListener('scroll', onScroll);

    return () => {
      rootEl.removeEventListener('scroll', onScroll);
    };
  }, [onScroll, rootEl]);

  return (
    <Grid container direction="column">
      <Grid item container>
        {children}
      </Grid>
      <Grid item container>
        {lastItem}
      </Grid>
    </Grid>
  );
};

export default InfiniteScroll;
